import { render, staticRenderFns } from "./GerenciamentoTransporteFilterBar.vue?vue&type=template&id=1542f727"
import script from "./GerenciamentoTransporteFilterBar.vue?vue&type=script&lang=js"
export * from "./GerenciamentoTransporteFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports